module.exports = __webpack_public_path__ + "img/icon-menu.cea2c68b.svg";